import moment from "moment";
import { Component, Prop, Watch } from "vue-property-decorator";
import { MonthDisplay } from "../../../../shared/interfaces/navigationMois.interface";
import { Debounce } from "../../../../shared/services/debounce.service";
import { VueBase } from "../../../Controls/VueBase";

@Component
export default class NavigationMoisComponent extends VueBase {
	@Prop({ required: true })
	public currentMonth!: number;

	@Prop({ required: true })
	public currentYear!: number;

	public localCurrentMonth = 0; // Mois actuellement utilisé pour la récupération des données - Initialisé à 0 pour éviter les erreurs de type avec moment.js
	public localCurrentYear = 0; // Année actuellement utilisée pour la récupération des données - Initialisé à 0 pour éviter les erreurs de type avec moment.js

	@Watch("currentMonth", { immediate: true })
	public onCurrentMonthChange(newVal: number): void {
		this.localCurrentMonth = newVal;
	}

	@Watch("currentYear", { immediate: true })
	public onCurrentYearChange(newVal: number): void {
		this.localCurrentYear = newVal;
	}

	/**
	 * Génère un tableau de 9 mois à afficher (mois actuel au centre)
     * @returns Tableau de 9 mois à afficher (mois actuel au centre)
	 */
	public get displayedMonths(): MonthDisplay[] {
		const currentMoment = moment([this.localCurrentYear, this.localCurrentMonth]);

		return Array.from({ length: 9 }, (_, i) => {
			const monthMoment = moment(currentMoment).add(i - 4, "months");

			return {
				month: monthMoment.month(),
				year: monthMoment.year(),
				label: `${monthMoment.format("MMMM")} ${monthMoment.year()}`,
				isCurrentMonth: this.isCurrentMonth(monthMoment.month(), monthMoment.year())
			};
		});
	}

    /**
     * Vérifie si le mois et l'année sont les mêmes que le mois et l'année actuelle
     * @param month Mois à vérifier
     * @param year Année à vérifier
     * @returns true si le mois et l'année sont les mêmes que le mois et l'année actuelle, false sinon
     */
	public isCurrentMonth(month: number, year: number): boolean {
		return month === this.localCurrentMonth && year === this.localCurrentYear;
	}

	/**
	 * Navigue vers le mois précédent (changement immédiat + debounce API)
     * @returns void
	 */
	public previousMonth(): void {
		this.updateLocalMonth(-1);
		this.emitMonthChangeDebounced();
	}

	/**
	 * Navigue vers le mois suivant (changement immédiat + debounce API)
	 */
	public nextMonth(): void {
		this.updateLocalMonth(1);
		this.emitMonthChangeDebounced();
	}

	/**
	 * Sélectionne un mois spécifique (sans debounce)
     * @param monthDisplay Mois à sélectionner
     * @returns void
	 */
	public selectMonth(monthDisplay: MonthDisplay): void {
		if (monthDisplay.month === this.localCurrentMonth && monthDisplay.year === this.localCurrentYear) {
			return;
		}

		this.localCurrentMonth = monthDisplay.month;
		this.localCurrentYear = monthDisplay.year;
		this.emitMonthChange();
	}

	/**
	 * Met à jour le mois local
     * @param offset Offset à ajouter au mois local
     * @returns void
	 */
	private updateLocalMonth(offset: number): void {
		const newDate = moment([this.localCurrentYear, this.localCurrentMonth]).add(offset, "months");
		this.localCurrentMonth = newDate.month();
		this.localCurrentYear = newDate.year();
	}

	/**
	 * Émet l'événement de changement immédiat
     * @returns void
	 */
	private emitMonthChange(): void {
		this.$emit("update-month", {
			month: this.localCurrentMonth,
			year: this.localCurrentYear
		});
	}

	/**
	 * Émet l'événement de changement avec debounce
     * @returns void
	 */
	@Debounce(500)
	private emitMonthChangeDebounced(): void {
		this.emitMonthChange();
	}
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsencesV2/calendrierMensuel/navigationMois/navigationMois.ts